module.exports = __webpack_public_path__ + "static/media/RecomendaDelRei.507a4670.jpg";